<template>
    <div id="wrapper" :class="langCss">
        <!-- start header -->
        <header>
            <div class="navbar navbar-default navbar-static-top">
                <div class="container">
                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle" data-toggle="collapse"
                            data-target=".navbar-collapse">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <router-link to="/" class="navbar-brand"><img src="/static/img/logo.png" alt="logo" /></router-link>
                    </div>
                    <div class="navbar-collapse collapse ">
                        <ul class="nav navbar-nav">
                            <li><router-link to="/" class="navbar-item">{{ $t('message.home') }}</router-link></li>
                            <li><router-link to="/services" class="navbar-item">{{ $t('message.serve') }}</router-link></li>
                            <!-- <li v-if="langCss != 'cn'"><a href="http://www.cflytrip.com" class="navbar-item" style="color:coral" >{{ $t('message.book') }}</a></li> -->
                            <li><router-link to="/portf" class="navbar-item">{{ $t('message.port') }}</router-link></li>
                            <!-- <li><router-link to="/aboutus" class="navbar-item">{{ $t('message.au') }}</router-link></li> -->
                            <li class="active"><router-link to="/pricing" class="navbar-item">{{ $t('message.pric') }}</router-link></li>
                            <li><router-link to="/contact" class="navbar-item">{{ $t('message.contact') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="ceswich">
                        <button style="background:none;border:none" :class="langCss === 'cn' ? 'xz' : ''"
                                @click="switchLang('cn')">{{ $t('message.switchCn') }}</button> |
                        <button style="background:none;border:none" :class="langCss === 'en' ? 'xz' : ''"
                                @click="switchLang('en')">{{ $t('message.switchEn') }}</button>
                    </div>
                </div>
            </div>
        </header>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">{{ $t('message.pric') }}</h2>
                    </div>
                </div>
            </div>
        </section>
            <section id="content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="txtContent">
                                <h3>{{ $t('message.pricTit') }}</h3>
                                <p>{{ $t('message.pricCon') }}</p>
                                <p>{{ $t('message.pricCon2') }}</p>
                            </div>
                            <!-- <a href="#" class="btn btn-color">Read more</a> -->
                        </div>
                    </div>
                    <!-- end divider -->
                    <div class="row">
                        <!-- <div class="col-lg-12">
                            <h4>{{$t('message.RecruitingPlan')}}</h4>
                        </div> -->
                        <div class="col-lg-3">
                            <div class="pricing-box-item">
                                <div class="pricing-heading">
                                    <h4 style="margin-top:20px"><strong>{{ $t('message.pricBase') }}</strong></h4>
                                </div>
                                <div class="pricing-terms">
                                    <h6>{{ $t('message.pricxz') }}</h6>
                                </div>
                                <div class="pricing-container">
                                    <ul>
                                        <li style="font-weight: bold;">{{$t('message.pricRespontit')}}</li>
                                        <li v-html="$t('message.pricResponCon')" style="text-align: left;height: 232px;padding:5px 5px;font-size: 12px;overflow: auto;scrollbar-width: none;"></li>
                                        <li style="font-weight: bold;">{{$t('message.pricResponsitit')}}</li>
                                        <li v-html="$t('message.pricResponsibility')" style="text-align: left;height: 366px;font-size: 12px;overflow: auto;scrollbar-width: none;"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="pricing-box-item">
                                <div class="pricing-heading">
                                    <h4 style="margin-top:20px"><strong>{{ $t('message.pricBase2') }}</strong></h4>
                                </div>
                                <div class="pricing-terms">
                                    <h6>{{ $t('message.pricxz2') }}</h6>
                                </div>
                                <div class="pricing-container">
                                    <ul>
                                        <li style="font-weight: bold;">{{$t('message.pricRespontit')}}</li>
                                        <li v-html="$t('message.pricResponCon2')" style="text-align: left;height: 232px;padding:5px 5px;font-size: 12px;"></li>
                                        <li style="font-weight: bold;">{{$t('message.pricResponsitit')}}</li>
                                        <li v-html="$t('message.pricResponsibility2')" style="text-align: left;height: 366px;font-size: 12px;"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="pricing-box-item activeItem">
                                <div class="pricing-heading">
                                    <h4 style="margin-top:20px"><strong>{{ $t('message.pricBase3') }}</strong></h4>
                                </div>
                                <div class="pricing-terms">
                                    <h6>{{ $t('message.pricxz3') }}</h6>
                                </div>
                                <div class="pricing-container">
                                    <ul>
                                        <li style="font-weight: bold;">{{$t('message.pricRespontit')}}</li>
                                        <li v-html="$t('message.pricResponCon3')" style="text-align: left;height: 232px;padding:5px 5px;font-size: 12px;"></li>
                                        <li style="font-weight: bold;">{{$t('message.pricResponsitit')}}</li>
                                        <li v-html="$t('message.pricResponsibility3')" style="text-align: left;height: 366px;font-size: 12px;"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="pricing-box-item">
                                <div class="pricing-heading">
                                    <h4 style="margin-top:20px"><strong>{{ $t('message.pricBase4') }}</strong></h4>
                                </div>
                                <div class="pricing-terms">
                                    <h6>{{ $t('message.pricxz4') }}</h6>
                                </div>
                                <div class="pricing-container">
                                    <ul>
                                        <li style="font-weight: bold;">{{$t('message.pricRespontit')}}</li>
                                        <li v-html="$t('message.pricResponCon4')" style="text-align: left;height: 232px;padding:5px 5px;font-size: 12px;"></li>
                                        <li style="font-weight: bold;">{{$t('message.pricResponsitit')}}</li>
                                        <li v-html="$t('message.pricResponsibility4')" style="text-align: left;height: 366px;font-size: 12px;"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="widget">
                                <address style="width:60%;float: left;">
                                    <strong>{{$t('message.addr')}}</strong><br>
                                    {{$t('message.addrcon')}}
                                </address>
                                <p style="margin-left:5%;width:30%;float: left;">
                                    <strong>{{$t('message.widgetCn')}}</strong><br>
                                    <i class="icon-phone"></i> {{$t('message.fixedTelephone')}} <br>
                                    <i class="icon-envelope-alt"></i> leo@cflytrip.com
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading"> {{$t('message.domestic')}} </h5>
                                <ul class="link-list">
                                    <li><a href="https://www.airchina.com.cn/" target="_blank">{{$t('message.flinkCon')}}</a></li>
                                    <li><a href="https://www.ceair.com/" target="_blank">{{$t('message.flinkCon2')}}</a></li>
                                    <li><a href="https://www.csair.com/" target="_blank">{{$t('message.flinkCon3')}}</a></li>
                                    <li><a href="https://www.hnair.com/" target="_blank">{{$t('message.flinkCon4')}}</a></li>
                                    <li><a href="https://www.cdal.com.cn" target="_blank">{{$t('message.flinkCon5')}}</a></li>
                                    <li><a href="https://www.loongair.cn" target="_blank">{{$t('message.flinkCon6')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.international')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.vietjet-air.com/" target="_blank">{{$t('message.flinkCon7')}}</a></li>
                                    <li><a href="https://www.koreanair.com/" target="_blank">{{$t('message.flinkCon8')}}</a></li>
                                    <li><a href="https://www.ana.co.jp/" target="_blank">{{$t('message.flinkCon9')}}</a></li>
                                    <li><a href="https://www.hkexpress.com/" target="_blank">{{$t('message.flinkCon10')}}</a></li>
                                    <li><a href="https://www.flyasiana.com/" target="_blank">{{$t('message.flinkCon11')}}</a></li>
                                    <li><a href="https://www.united.com/" target="_blank">{{$t('message.flinkCon12')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.platform')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.ctrip.com/" target="_blank">{{$t('message.flinkCon13')}}</a></li>
                                    <li><a href="https://www.qunar.com/" target="_blank">{{$t('message.flinkCon14')}}</a></li>
                                    <li><a href="https://www.ly.com/" target="_blank">{{$t('message.flinkCon15')}}</a></li>
                                    <li><a href="https://www.fliggy.com/" target="_blank">{{$t('message.flinkCon16')}}</a></li>
                                    <li><a href="https://www.meituan.com/" target="_blank">{{$t('message.flinkCon17')}}</a></li>
                                    <li><a href="https://buyer.pkfare.com/" target="_blank">{{$t('message.flinkCon18')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div id="sub-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="copyright">
                                    <p>
                                        <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2020020380号-1</a>
                                        <span>&copy; Copyright ©2024 晨飞旅业 All Rights Reserved. </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6" style="position: relative;">
                              <a class="rztz" href="http://cx.cnca.cn/CertECloud/result/skipResultList?certNumber=05324I10341R0M%20%20%20&orgName=&fromIndex=true" target="_blank"><img class="ISO2007RZ" src="/static/img/rz2007.png" alt=""></a>
                                <!-- <ul class="social-network">
                                    <li>
                                        <a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
    </div>
</template>

<script>
export default {
    name: "pricing",
    data() {
        return {
            langCss: window.localStorage.getItem("lang"),
            dialogVisible: false,
            currentUrl: ""
        };
    },
    methods: {
        switchLang(lang) {
            this.$i18n.locale = lang;
            //把语言保存在localStorage中
            localStorage.setItem("lang", lang);
            //切换父级class
            this.langCss = lang;
        },
        handleClose(done) {
            this.$confirm(this.$t("message.confirm")) //js内部切换
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-css button {
    width: 150px;
}

.en .vue-css button {
    color: steelblue;
}

.cn .vue-css button {
    color: #666;
}

.ja .vue-css button {
    color: seagreen;
}

.xz {
    color: #37A691
}
</style>



// WEBPACK FOOTER //
// src/views/pricing/pricing.vue